module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patrimonial-form"
  }, [_c('form', {
    staticClass: "form-ui landscape-patrimonial-ui",
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('année de retraite')
    }
  }, [_c('label', {
    attrs: {
      "for": "montant"
    }
  }, [_vm._v("Date estimée de votre départ en retraite")]), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.months,
      "selected": _vm.month
    },
    on: {
      "change": function($event) {
        _vm.month = $event
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.yearOfRetreat),
      expression: "yearOfRetreat"
    }],
    staticClass: "border-left",
    attrs: {
      "type": "text",
      "name": "année de retraite",
      "placeholder": "Année de retraite"
    },
    domProps: {
      "value": (_vm.yearOfRetreat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.yearOfRetreat = $event.target.value
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ctn-toggle row"
  }, [_c('radio-box', {
    model: {
      value: (_vm.hasNotRetirement),
      callback: function($$v) {
        _vm.hasNotRetirement = $$v
      },
      expression: "hasNotRetirement"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\tJe ne sais pas\n\t\t\t")])], 1), _vm._v(" "), _c('div', {
    staticClass: "ctn-toggle row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\tDétenez vous des plans d'épargne retraites ?\n\t\t\t")]), _vm._v(" "), _c('custom-toggle', {
    attrs: {
      "value": _vm.isPERP
    },
    on: {
      "change": function($event) {
        _vm.isPERP = $event
      }
    }
  })], 1), _vm._v(" "), (_vm.isPERP) ? _c('div', {
    staticClass: "ctn-tags row"
  }, _vm._l((_vm.PERPType), function(perp, key) {
    return _c('div', {
      key: key,
      staticClass: "tag",
      class: {
        active: _vm.isActiveTag(perp)
      },
      on: {
        "click": function($event) {
          return _vm.toggleTag(perp)
        }
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(perp) + "\n\t\t\t")])
  }), 0) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11ff07af"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/MyPatrimonialLandscape/Retreat.vue
// module id = 1070
// module chunks = 0